"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Radio = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helpers = require("@paprika/stylers/lib/helpers");

var _includes = require("@paprika/stylers/lib/includes");

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _types = _interopRequireDefault(require("./types"));

var _styles;

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getLabelLeftPadding = function getLabelLeftPadding(radioSize, hasLabel) {
  return hasLabel ? "".concat((0, _helpers.toInt)(radioSize) + (0, _helpers.toInt)(_tokens["default"].space), "px") : radioSize;
};

var smallRadioSize = _tokens["default"].radio.sizeSm;
var mediumRadioSize = _tokens["default"].radio.sizeMd;

var getHalfSizeCss = function getHalfSizeCss(sizeCss) {
  return "".concat((0, _helpers.toInt)(sizeCss) / 2, "px");
};

var smallRadioHalfSize = getHalfSizeCss(smallRadioSize);
var mediumRadioHalfSize = getHalfSizeCss(mediumRadioSize);
var generalRadioStyle = {
  radioStyles: {
    height: mediumRadioSize,
    width: mediumRadioSize,
    borderRadius: mediumRadioHalfSize
  },
  radioIconBackgroundStyles: {
    borderRadius: "6px",
    height: "10px",
    top: "5px",
    width: "10px"
  },
  radioIconStyles: {
    fontSize: "".concat((0, _helpers.fontSizeValue)(-2), "px"),
    height: mediumRadioSize,
    left: mediumRadioHalfSize
  }
};
var styles = (_styles = {}, (0, _defineProperty2["default"])(_styles, _types["default"].size.SMALL, {
  baseFontSize: {
    fontSize: "".concat((0, _helpers.fontSizeValue)(-1), "px")
  },
  radioStyles: {
    height: smallRadioSize,
    width: smallRadioSize,
    borderRadius: smallRadioHalfSize
  },
  radioIconBackgroundStyles: {
    borderRadius: "4px",
    height: "8px",
    top: "4px",
    width: "8px"
  },
  radioIconStyles: {
    fontSize: "".concat((0, _helpers.fontSizeValue)(-4), "px"),
    height: smallRadioSize,
    left: smallRadioHalfSize
  },
  labelStyles: function labelStyles(hasLabel) {
    return {
      minHeight: smallRadioSize,
      padding: "0 0 0 ".concat(getLabelLeftPadding(smallRadioSize, hasLabel))
    };
  }
}), (0, _defineProperty2["default"])(_styles, _types["default"].size.MEDIUM, _objectSpread(_objectSpread({}, generalRadioStyle), {}, {
  baseFontSize: {
    fontSize: "".concat((0, _helpers.fontSizeValue)(-1), "px")
  },
  labelStyles: function labelStyles(hasLabel) {
    return {
      minHeight: mediumRadioSize,
      padding: "1px 0 0 ".concat(getLabelLeftPadding(mediumRadioSize, hasLabel))
    };
  }
})), (0, _defineProperty2["default"])(_styles, _types["default"].size.LARGE, _objectSpread(_objectSpread({}, generalRadioStyle), {}, {
  baseFontSize: {
    fontSize: "".concat((0, _helpers.fontSizeValue)(), "px")
  },
  labelStyles: function labelStyles(hasLabel) {
    return {
      minHeight: mediumRadioSize,
      padding: "0 0 0 ".concat(getLabelLeftPadding(mediumRadioSize, hasLabel))
    };
  }
})), _styles);

var Radio = _styledComponents["default"].div.withConfig({
  displayName: "Radiostyles__Radio",
  componentId: "sc-13b9zak-0"
})(function (_ref) {
  var size = _ref.size,
      hasLabel = _ref.hasLabel;
  return (0, _styledComponents.css)(["", ";", ";", ";line-height:", ";position:relative;& + [data-pka-anchor=\"radio\"]{margin-top:", ";}input[type=\"radio\"]{", ";& + label{cursor:pointer;display:inline-block;margin:0;", ";position:relative;}& + label::before,& + label > .radio-icon{position:absolute;top:0;}& + label::before{", ";", ";background:", ";border:2px solid ", ";content:\"\";left:0;}& + label:hover::before{border:2px solid ", ";}& + label > .radio-icon{", ";", ";color:", ";opacity:0;pointer-events:none;transform:translateX(-50%);transition:opacity 0.15s ease-out;}& + label > .radio-solid-background{", ";background-color:", ";}&:checked{& + label.deselectable:hover:before{background:", ";}& + label::before{border:2px solid ", ";}}&:checked + label > [data-pka-anchor=\"radio.icon.check\"]{opacity:1;}&:disabled{& + label,& ~ .radio-icon{cursor:not-allowed;opacity:0.5;transition:none;}& + label:before{border:2px solid ", ";}&:checked{& + label:hover::before{border:2px solid ", ";}& + label.deselectable:hover:before{background-color:inherit;}}& + label:hover::before{border:2px solid ", ";}}&:focus + label::before{border-color:", ";box-shadow:", ";}}"], _includes.boxSizingStyles, styles[size].baseFontSize, (0, _helpers.z)(0), hasLabel ? (0, _helpers.lineHeightValue)(-1) : "0", _tokens["default"].space, _includes.visuallyHidden, styles[size].labelStyles(hasLabel), styles[size].radioStyles, (0, _helpers.z)(1), _tokens["default"].color.white, _tokens["default"].color.blackLighten40, _tokens["default"].color.black, styles[size].radioIconStyles, (0, _helpers.z)(2), _tokens["default"].color.black, styles[size].radioIconBackgroundStyles, _tokens["default"].color.black, _tokens["default"].color.blackLighten60, _tokens["default"].color.black, _tokens["default"].color.blackLighten60, _tokens["default"].color.black, _tokens["default"].color.blackLighten60, _tokens["default"].highlight.active.noBorder.borderColor, _tokens["default"].highlight.active.noBorder.boxShadow);
});

exports.Radio = Radio;
//# sourceMappingURL=Radio.styles.js.map